export * from "./sotprice.pipe";
